import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type Props = {
  direction?: 'row' | 'column';
  gap?: number;
  items?: string;
  justify?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'FrkFlexContainer',
  props: {
    direction: { default: 'row' },
    gap: { default: 2 },
    items: { default: 'center' },
    justify: { default: 'start' }
  },
  setup(__props: any) {

const props = __props as { direction: 'row' | 'column', gap: number, items: string, justify: string };



const flexGapClass = computed(() => `tw-gap-${props.gap}`);
const flexItems = computed(() => `tw-items-${props.items}`);
const flexJustify = computed(() => `tw-justify-${props.justify}`);
const flexDirection = computed(() => (props.direction === 'column' ? 'tw-flex-col' : 'tw-flex-row'));

return { __sfc: true,props, flexGapClass, flexItems, flexJustify, flexDirection }
}

})